import { useEffect } from "react";
import {
  useAppSelector,
  // useAppDispatch
} from "../../redux/store";
// import { Navigate } from "react-router";
import { useSnackbar } from "notistack";

import PaymentForm from "./components/PaymentForm"; // fix this

const Login = () => {
  const { paymentSuccess, paymentError } = useAppSelector((state) => state.login) as any;
  // const dispatch = useAppDispatch();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (paymentSuccess) {
      enqueueSnackbar("Payment successful!", { variant: "success" });
    }

    if (paymentError) {
      enqueueSnackbar(`Payment failed. ${paymentError}.`, { variant: "error" });
    }
  }, [enqueueSnackbar, paymentSuccess, paymentError]);

  // if (loginSuccess) {
  //   return (
  //     <Navigate to={`${user?.role === "admin" ? "/dashboard" : "/project-home"}`} />
  //   );
  // }

  return <PaymentForm />;
};

export default Login;
